import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from '@rails/activestorage'

export default class extends Controller {
  static values = {
    previewUrl: String
  }

  connect() {
    this.element.addEventListener('change', this.uploadFiles.bind(this))
  }

  uploadFiles() {
    Array.from(this.element.files).forEach(file => this.uploadFile(file))
    this.element.value = null
  }

  uploadFile(file) {
    const upload = new DirectUpload(file, this.element.dataset.directUploadUrl)

    upload.create((error, blob) => {
      if (error) return

      if (this.hasPreviewUrlValue)
        this.preview(blob)
      else
        this.appendHiddenField(blob)
    })
  }

  appendHiddenField(blob) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('value', blob.signed_id);
    hiddenField.name = this.element.name
    this.element.closest('form').appendChild(hiddenField)
  }

  preview(blob) {
    const url = new URL(this.previewUrlValue)
    url.searchParams.append('blob_signed_id', blob.signed_id)
    fetch(url, { headers: { accept: 'text/vnd.turbo-stream.html', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(response => response.text())
      .then((data) => {
        Turbo.renderStreamMessage(data)
      })
  }
}